<!-- todo Check with activeSubItem // and maybe create a ng-template ? and handle scrollTrigger for subItems -->
@if (activeMenu()) {
  <div
    class="sticky-tab-list fixed left-0 top-0 z-120 block h-screen w-screen overflow-x-auto bg-white py-3 pr-4 scrollbar-hide"
    [class.pt-10]="isNotched()"
    [class.shadow-none]="isNotched()"
    [class.border-b]="isNotched()"
    [ngClass]="{
      'block bg-white fixed top-0 left-0 z-120 h-screen w-screen py-3': activeMenu(),
      'px-5 lg:px-12': !displayBurgerNavigation(),
      'lg:pr-12': displayBurgerNavigation(),
    }"
    #scrollSection
  >
    <div
      *ngIf="activeMenu() || search()"
      class="w-full text-left"
      [ngClass]="{
        'px-5 lg:px-12': activeMenu(),
      }"
    >
      <app-rounded-icon-button
        *ngIf="activeMenu()"
        class="mr-4"
        [outlined]="true"
        [icon]="'icon-cross font-bold'"
        [size]="'sm'"
        [fontSize]="'text-xs'"
        [overrideBackgroundColor]="burgerBackgroundColor()"
        [overrideColor]="burgerIconColor()"
        (click)="toggleMenu()"
      ></app-rounded-icon-button>
      <app-rounded-icon-button
        *ngIf="search()"
        class="mr-4"
        [outlined]="true"
        [icon]="'icon-zoom font-bold'"
        [size]="'sm'"
        [fontSize]="'text-base'"
        [overrideBackgroundColor]="burgerBackgroundColor()"
        [overrideColor]="burgerIconColor()"
        (click)="toggleSearch()"
      ></app-rounded-icon-button>
    </div>
    <ng-container
      *ngTemplateOutlet="tabMenuSection; context: { data: typedTplDataEntry(treeTabsUI(), 0) }"
    />
  </div>
}
<ng-container
  *ngTemplateOutlet="tabSection; context: { data: typedTplDataEntry(treeTabsUI(), 0) }"
/>

<ng-template
  #tabSection
  let-unTypedTplData="data"
>
  <!-- todo remove activeMenu relation here -->
  @let treeTabsSection = typedTplData(unTypedTplData);
  @let sectionColors = categoriesColorsByLevel()[treeTabsSection.level];

  <div
    class="shadow-xs mx-auto flex items-center justify-center text-center shadow"
    [style.backgroundColor]="sectionColors.backgroundColor | contentBuilderColor"
  >
    @if (treeTabsSection.level === 0) {
      <div #btnMenu>
        <app-rounded-icon-button
          *ngIf="!activeMenu() && displayBurgerNavigation()"
          class="px-5 lg:pl-12"
          [outlined]="true"
          [icon]="'icon-hamburger font-bold'"
          [size]="'sm'"
          [fontSize]="'text-xs'"
          [overrideBackgroundColor]="burgerBackgroundColor()"
          [overrideColor]="burgerIconColor()"
          (click)="toggleMenu()"
        ></app-rounded-icon-button>
      </div>
    }

    @let activeTab = treeTabsSection.data | appFn: getActiveTab;
    <div
      appHorizontalScroll
      [appScrollToId]="'tabList-' + activeTab.id"
      class="sticky-tab-list flex w-full items-center overflow-x-auto bg-white pr-4 scrollbar-hide"
      [class.pt-10]="isNotched()"
      [class.shadow-none]="isNotched()"
      [class.border-b]="isNotched()"
      [ngClass]="{
        'px-5 lg:px-12': !displayBurgerNavigation(),
        'lg:pr-12': displayBurgerNavigation(),
      }"
      #scrollSection
    >
      <div class="flex items-center">
        @for (treeTab of treeTabsSection.data; track $index) {
          <button
            [id]="'tabList-' + treeTab.id"
            class="relative mr-3 flex items-center whitespace-nowrap border-b-4 px-2 py-3 font-accent font-semibold lg:py-5"
            [class.scroll-target-item]="treeTab.isActive"
            [style.borderColor]="
              treeTab.isActive ? (sectionColors.activeColor | contentBuilderColor) : 'transparent'
            "
            [style.color]="
              treeTab.isActive
                ? (sectionColors.activeColor | contentBuilderColor)
                : (sectionColors.inactiveColor | contentBuilderColor)
            "
            (click)="tabClick(treeTab.id)"
          >
            {{ treeTab.name }}
            <span
              *ngIf="treeTab.icon"
              class="text-8px transform rotate-180 icon icon-{{ treeTab.icon }} ml-2"
            ></span>
          </button>
        }
      </div>
    </div>
  </div>
  <!-- IF the selected tab has children -> display another tab section -->
  @if (activeTab?.children && activeTab.children.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        tabSection;
        context: { data: typedTplDataEntry(activeTab.children, treeTabsSection.level + 1) }
      "
    />
  }
</ng-template>

<ng-template
  #tabMenuSection
  let-unTypedTplData="data"
>
  @let treeTabsSection = typedTplData(unTypedTplData);
  @let sectionColors = categoriesColorsByLevel()[treeTabsSection.level];

  <div class="py-2 pl-4"></div>
  @for (treeTab of treeTabsSection.data; track $index) {
    <div class="mb-2">
      <button
        class="flex w-full items-center rounded-lg px-3 py-2 text-left font-accent transition-colors duration-200"
        [style.color]="sectionColors.activeColor | contentBuilderColor"
        (click)="tabClick(treeTab.id)"
      >
        <span>{{ treeTab.name }}</span>
        <span
          *ngIf="treeTab.children && treeTab.children.length > 0"
          class="ml-auto rotate-90 transform text-xs"
        >
          <span class="icon icon-chevron-right"></span>
        </span>
      </button>

      <!-- Recursive children -->
      @if (treeTab.children && treeTab.children.length > 0) {
        <div
          class="ml-4 mt-1 border-l-2 pl-2"
          [style.borderColor]="sectionColors.activeColor | contentBuilderColor"
        >
          <ng-container
            *ngTemplateOutlet="
              tabMenuSection;
              context: {
                data: typedTplDataEntry($any(treeTab.children), treeTabsSection.level + 1),
              }
            "
          />
        </div>
      }
    </div>
  }
</ng-template>
